// extracted by mini-css-extract-plugin
export default {"inputWrapper":"RenameViewModal_inputWrapper__b4wkF"};